// extracted by mini-css-extract-plugin
export var slider = "index-module--slider--QphIQ";
export var sliderNav = "index-module--sliderNav---X70L";
export var sliderNavSlide = "index-module--sliderNavSlide--ix72v";